import { gql } from 'graphql-request'

export const QueryNavigationItem = gql`
  fragment FragmentNavigationItem on NavigationItemModelRecord {
    id
    title
    subtext
    externalUrl
    accessibleText
    relativePath
    sendUtmParams
    icon
    trackingId
    image {
      title
      alt
      filename
      url
    }
    logo {
      title
      alt
      filename
      url
    }
    background {
      title
      alt
      filename
      url
    }
    content {
      __typename
      ... on IntegrationModelRecord {
        id
        title
        slug
      }
      ... on CustomerModelRecord {
        id
        title
        slug
      }
      ... on ArticleModelRecord {
        id
        title
        slug
        categories {
          id
          slug
        }
      }
      ... on PageModelRecord {
          id
        title
        slug
        enabledMarkets {
          slugPrefix
        }
      }
      ... on WistiaVideoModelRecord {
        id
        videoId
      }
    }
  }
`
